import React from 'react';

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    color: '#333',
    padding: '2rem',
    maxWidth: '900px',
    margin: '0 auto',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  } as React.CSSProperties,
  header: {
    textAlign: 'center' as React.CSSProperties['textAlign'],
    marginBottom: '2rem',
    borderBottom: '2px solid #0056b3', // A shade of blue
    paddingBottom: '1rem',
  } as React.CSSProperties,
  h1: {
    color: '#0056b3',
    fontSize: '2.5rem',
    marginBottom: '0.5rem',
  } as React.CSSProperties,
  p: {
    lineHeight: '1.6',
    marginBottom: '1rem',
  } as React.CSSProperties,
  section: {
    marginBottom: '2rem',
  } as React.CSSProperties,
  sectionTitle: {
    color: '#0056b3',
    fontSize: '1.8rem',
    marginBottom: '1rem',
    borderLeft: '4px solid #4CAF50', // A shade of green
    paddingLeft: '1rem',
  } as React.CSSProperties,
  subSectionTitle: {
    color: '#4CAF50',
    fontSize: '1.4rem',
    marginTop: '1.5rem',
    marginBottom: '1rem',
  } as React.CSSProperties,
  list: {
    listStyleType: 'none',
    padding: '0',
  } as React.CSSProperties,
  listItem: {
    backgroundColor: '#f9f9f9',
    padding: '1rem',
    marginBottom: '0.5rem',
    borderRadius: '4px',
    border: '1px solid #eee',
  } as React.CSSProperties,
  footer: {
    textAlign: 'center' as React.CSSProperties['textAlign'],
    marginTop: '2rem',
    paddingTop: '1rem',
    borderTop: '1px solid #ddd',
    color: '#666',
  } as React.CSSProperties,
};

const UserManual: React.FC = () => {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.h1}>USER MANUAL</h1>
      </header>
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>1. Navigating the Marketplace</h2>
        <p style={styles.p}>
          Gremaglobal.com is a global platform designed to help customers easily find what they need within their localities while at the same time businesses are helped to find the customers they need. The platform also has real estate services provided by Grema.
          Below is a step-by-step guide on how to use the platform;
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>Homepage:</strong> The home page brings you back to the front page of the platform from browsing the listing of your choice (All business adverts, Premium adverts and real estate and properties) . Listings are displayed in a card format with a photo, title, price and other relevant details.</li>
          <li style={styles.listItem}><strong>General Search Bar:</strong> Use the search bar at the top of the page to find specific products, services, or businesses. You can search using keywords like "House," "Car," or "used cars."</li>
          <li style={styles.listItem}><strong>Location Search Bar:</strong> After searching what you want under general search, use the location search bar at the top of the page to only list the searched items in your location of interest.</li>
          <li style={styles.listItem}><strong>Categories:</strong> The sidebars on the left(All businesses adverts) and right (GREMA Real Estate& Properties) let you filter listings by category. Simply click on a category like "Restaurants & Cafes,"  or "Jobs & Careers"  or “Land” to see all related listings. The number next to each category shows you how many active listings are available in that category. The you can apply the filters of interest as explained above</li>
        </ul>
      </div>
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>2. Viewing Business & Listing Details</h2>
        <p style={styles.p}>
          Once you find a listing that interests you, click on it or click on “View this business” to open the Business Details Page.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>Media Gallery:</strong> The main part of the page displays a gallery of photos and videos for the listing. Click on any media item to view a larger, zoomed-in version.</li>
          <li style={styles.listItem}><strong>Listing Information:</strong> To the right of the media, you'll find details about the specific product or service, including its title, price, and description. You can also see how many people have viewed or favorited the listing.</li>
          <li style={styles.listItem}><strong>Business Profile (Left Sidebar):</strong> The sidebar provides information about the business itself. Here you'll find the <strong>business name</strong>, <strong>location</strong>, and <strong>contact information</strong>. This is where you can learn more about the seller and their business type (e.g., Premium, Standard).</li>
          <li style={styles.listItem}><strong>Contacting the Business:</strong> If a business has provided a WhatsApp number, you can click on the WhatsApp link to start a direct chat.</li>
          <li style={styles.listItem}><strong>Navigation:</strong> If a business has multiple listings, use the <strong>"Next"</strong> and <strong>"Previous"</strong> buttons at the bottom of the media gallery to cycle through them.</li>
        </ul>
      </div>
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>3. Buying Advertising space Posting</h2>
        <p style={styles.p}>
          To buy advertising space, first prepare media and save it on your computer or phone
          The proceed and click “Advertise Here”. Read the policy before proceeding. If you agree to the terms and conditions, click “I agree and Continue” and fill all the profile information. After filling profile information, click “submit and proceed to payment”. Then select payment method, input telephone number or card number with CVV and click “proceed” to complete payment on your phone or card. After completing payment, a page where you are to add your media and descriptions will appear. Add all the different types of media as described in the policy. Click finish posting and then you will return to home page to view your postings.
        </p>
      </div>
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>4. Updating Advertising space Posting</h2>
        <p style={styles.p}>
          As long as your subscription is still active, you can update your media items by deleting existing media and adding new ones, or if you still had space to add items then you will able to add them.
          To do this, first prepare your media items on phone or computer. Then search your stall number if you don’t remember it or if you remember it then have it ready with you. Add both the stall number and business phone number in the dialogue that opens. An OTP (6 digits) will be sent to your phone number. Insert the OTP sent to your number and the page for updating media will be displayed. Update your media and after click “Finish posting” to return to home page.
        </p>
      </div>
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>3. Renewing Advertising space Posting</h2>
        <p style={styles.p}>
          First prepare media and save it on your computer of phone. Then search your stall number if you don’t remember it or if you remember it then have it ready with you. Add both the stall number and business phone number in the dialogue that opens. An OTP (6 digits) will be sent to your phone number. Insert the OTP sent to your number and your profile will be displayed together with payment page. Make payment and then the page for updating media will be displayed. Update your media and after click “Finish posting” to return to home page.
        </p>
      </div>
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>4. Posting a Listing (For Business Owners)</h2>
        <p style={styles.p}>
          When posting as a stall owner, follow the following simple steps.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>Log in:</strong> Buy a stall or click update stall or click renew stall to access your business dashboard.</li>
          <li style={styles.listItem}><strong>Create a New Listing:</strong> Click on the "Post new Advert"</li>
          <li style={styles.listItem}><strong>Media upload:</strong> After clicking "Post new Advert", a form will appear, select media type (Item image, Video and General Media) and fill in all the information about the selected media type, including the title/description and price (where applicable).</li>
          <li style={styles.listItem}><strong>Upload Media:</strong> Click “Choose file” to upload high-quality photos/images and videos to showcase your listing. After attaching the media you want, click “Add Video/Item Image/General Image”</li>
          <li style={styles.listItem}><strong>Submit:</strong> Click After the steps above, click “Post Ad” and your media will be visible on your business page for customers to view it. You can add multiple images/photos and videos based on your subscription. Finally, when you have finished adding all the media you want, click “Finish posting” at the top right corner to return to the home page.</li>
        </ul>
      </div>
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>5. Managing Your Profile</h2>
        <p style={styles.p}>
          Your business dashboard gives you an overview of your activity.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>Dashboard:</strong> You can see your active listings, their views, and other performance metrics.</li>
          <li style={styles.listItem}><strong>Edit Profile:</strong> Click on the "Edit Profile" or "Settings" section to update your business information, including your business name, contact details, and social media links.</li>
          <li style={styles.listItem}><strong>Manage Listings:</strong> From your dashboard, you can edit or delete your existing listings at any time.</li>
        </ul>
      </div>
      <footer style={styles.footer}>
        <p>If you have any questions or need further assistance, please contact our support team. We're here to help you get the most out of Grema!</p>
      </footer>
    </div>
  );
};

export default UserManual;